import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { AssociateType } from "../../../components/filter/types/AssociateType";
import { fetchAssociateRegions } from "../thunks/fetchAssociateRegions";
import { IAssociateState } from "../types/IAssociateState";
import { selectMatchingItems } from "../utils/selectMatchingItems";
import { setMatchingItemFilter } from "../utils/setMatchingItemFilter";
import { updateSuggestedOnFetchComplete } from "./utils/updateSuggestedOnFetchComplete";

export const addFetchAssociateRegions = (builder: ActionReducerMapBuilder<IAssociateState>) => {
  builder.addCase(fetchAssociateRegions.pending, (state, action) => {
    state.loadingKeys = [...state.loadingKeys, `${action.meta.arg.operator}`];
  });
  builder.addCase(fetchAssociateRegions.rejected, (state, action) => {
    state.loadingKeys = state.loadingKeys.filter((itm) => itm !== `${action.meta.arg.operator}`);
  });
  builder.addCase(fetchAssociateRegions.fulfilled, (state, action) => {
    state.loadingKeys = state.loadingKeys.filter((itm) => itm !== `${action.meta.arg.operator}`);
    state.regions[action.meta.arg.operator] = [...action.payload];

    if (action.meta.arg.noSuggestions !== true) {
      selectMatchingItems(
        state.operators.map((itm) => itm.id),
        state,
        state.tezTargets,
        action.meta.arg.operator,
        AssociateType.regions,
      );
      updateSuggestedOnFetchComplete(state, action.meta.arg.operator, action.payload);
    } else {
      const regionFilter = state.filterRegion[10];
      const currentFilter = state.filterRegion[action.meta.arg.operator];
      if (regionFilter && !currentFilter) {
        setMatchingItemFilter(10, regionFilter, state, "region");
      }
    }
  });
};
